<div class="mat-subheading-2">{{ programMode ? 'Choose a template to start with' : 'Select a template' }}</div>
<mat-dialog-content *ngIf="templates" id="template-choices" [class.program-mode]="programMode">
  <ng-container *ngFor="let template of templates" [ngSwitch]="programMode">
    <simulation-template-card *ngSwitchCase="true" [template]="template" [inactive]="inactive"
      (templateSelected)="onTemplateSelected($event)"></simulation-template-card>
    <template-card *ngSwitchCase="false" [template]="template" [inactive]="inactive"
      (templateSelected)="onTemplateSelected($event)"></template-card>
  </ng-container>
</mat-dialog-content>